export default __webpack_public_path__ + "static/media/ic_linkedIn.28f19c96.svg";